/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../../../../../../../_metronic/helpers'

type Props = {
  show: boolean
  handleClose: () => void
  id: string
  reponsables: any
}

const ModalUsersResp: React.FC<Props> = ({reponsables}) => {
  const intl = useIntl()

  const [search, setSearch] = useState('')
  return (
    <div className='modal fade' tabIndex={-1} id='kt_modal_users'>
      <div className='modal-dialog modal-dialog-centered mw-600px h-auto'>
        <div className='modal-content'>
          <div className='modal-body'>
            <div className='modal-header d-flex justify-align-content-between border-0'>
              {/* begin::Close */}
              <span className='fw-bold text-dark fs-4 '>
                {intl.formatMessage({id: 'USER.RESPONSIBLE'})}
              </span>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />

                {/* end::Close */}
              </div>
            </div>

            <div className='d-flex align-items-center position-relative my-1 px-5'>
              <input
                type='text'
                data-kt-user-table-filter='search'
                className='form-control form-control-solid form-control-sm w-250px ps-5'
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder={
                  intl.formatMessage({id: 'COMMON.SEARCH'}) +
                  ' ' +
                  intl.formatMessage({id: 'USER.RESPONSIBLE'})
                }
              />
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-1 position-absolute end-50 pe-10 '
              />
            </div>
            {/* end::Search */}

            <div className='table-responsive p-5'>
              {/* begin::Table */}
              <table className='table align-middle  gs-0 gy-4'>
                {/* begin::Table head */}
                <thead>
                  <tr className='fw-bold text-muted bg-light text-center'>
                    <th className='min-w-150px rounded-start'>
                      {intl.formatMessage({id: 'CLOUDFILE.INPUT_USER_ID'})}
                    </th>
                    <th className='min-w-150px rounded-start'>
                      {intl.formatMessage({id: 'USER.RESPONSIBLE'})}
                    </th>
                  </tr>
                </thead>
                {/* end::Table head */}
                {/* begin::Table body */}
                <tbody>
                  {reponsables
                    .filter((busca: any) => {
                      return search.toLowerCase() === ''
                        ? busca
                        : busca?.firstname.toLowerCase().includes(search)
                    })
                    .map((uses: any) => {
                      return (
                        <tr key={uses.id}>
                          <td>
                            <div className='d-flex align-items-center justify-content-center'>
                              <div className='symbol symbol-50px me-5'></div>
                              <div className='d-flex flex-column'>
                                <a
                                  href=''
                                  className='fw-semibold text-gray-600 d-block fs-7'
                                  data-bs-dismiss='modal'
                                >
                                  {uses.id}
                                </a>
                              </div>
                            </div>
                          </td>

                          <td>
                            <span className='fw-semibold text-gray-600 d-block fs-7 text-center'>
                              {uses?.firstname}
                            </span>
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
              {/* end::Table body */}
              {/* end::Table */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {ModalUsersResp}
